/** @jsxImportSource @emotion/react */
import { useEffect, useState } from 'react';

import OrderTrackingResults from './Results/OrderTrackingResults';
import TrackingForm from './TrackingForm';

import type { OrderStatusDto } from '@vitafy/storefront-api-contracts-fetch';

const OrderTrackingLP: React.FC = () => {
  const [page, setPage] = useState('trackingForm');
  const [trackingData, setTrackingData] = useState<OrderStatusDto | undefined>(undefined);

  // Load tracking data from localStorage on component mount
  useEffect(() => {
    const savedTrackingData = localStorage.getItem('trackingData');
    if (savedTrackingData) {
      setPage('results');
      setTrackingData(JSON.parse(savedTrackingData));
    }
  }, []);

  // Save tracking data to localStorage whenever it changes
  useEffect(() => {
    if (trackingData) {
      localStorage.setItem('trackingData', JSON.stringify(trackingData));
    }
  }, [trackingData]);

  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'center',
        padding: '2rem'
      }}
    >
      {page === 'trackingForm' ? (
        <TrackingForm setPage={setPage} setTrackingData={setTrackingData} />
      ) : (
        typeof trackingData !== 'undefined' && (
          <OrderTrackingResults setPage={setPage} trackingData={trackingData} />
        )
      )}
    </div>
  );
};

export default OrderTrackingLP;
